import React from 'react';

/**
 * CheckIcon is a functional component that renders a checkmark icon.
 * It is used within the Checkbox component to visually indicate the "checked" state.
 */
const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-4 h-4 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
  </svg>
);

export default CheckIcon;
